// extracted by mini-css-extract-plugin
export default {"signInDisclaimer":"SignInDisclaimer_signInDisclaimer__smsA3","icon":"SignInDisclaimer_icon__Ml3lf","underlineText":"SignInDisclaimer_underlineText__NI0hO"};